// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__hyUL9","title":"InfoRow_title__2iKBU"};